import axios from 'axios'

import { CalculationServiceGreenGRPApi } from '../../../publish/calculation/apis/calculation-service-green-grpapi'
import { Configuration } from '../../../publish/calculation/configuration'
import { setupAxiosInterceptors } from '../../axios-interceptor-utils'

export class CalculationServiceGreenGRP extends CalculationServiceGreenGRPApi {
  constructor(
    protected basePath: string,
    private getTokenFn?: () => Promise<string>,
  ) {
    super(new Configuration({ basePath: basePath }), basePath, axios.create())
    setupAxiosInterceptors(this.axios, this.getTokenFn)
  }
}
